export default __webpack_public_path__ + "static/media/13473_RZ_Energy_Experience_Outdoorstelen_A11 9.0fc97cbf.pdf";